import "../../CSS/layout/footer.css";
import React from "react";
import { Link } from "react-router-dom";
import CallIcon from "@mui/icons-material/Call";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import LogoWhite from "../../assets/HomePage/logo.svg";
import { categories } from "../ProductPage/products";
import { offices, SERVICE_AREA } from "./contactInfo";

function SiteFooter() {
  return (
    <footer className="dm-footer">
      <div className="dm-container">
        <div className="dm-footer-top">
          <div className="dm-footer-brand">
            <img src={LogoWhite} alt="Delmen Mosquito Screens" width="150" height="46" />
            <p>
              Custom-made mosquito screens for doors and windows since 1999. The
              first in India to introduce magnetic mosquito nets.
            </p>
            <p className="dm-footer-area">{SERVICE_AREA}</p>
          </div>

          <div className="dm-footer-col">
            <p className="dm-footer-heading">Products</p>
            <ul>
              {categories.map((category) => (
                <li key={category.id}>
                  <Link to={`/ourproducts#${category.id}`}>{category.name}</Link>
                </li>
              ))}
              <li>
                <Link to="/ourproducts">All products</Link>
              </li>
            </ul>
          </div>

          <div className="dm-footer-col">
            <p className="dm-footer-heading">Company</p>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/companyprofile">Company Profile</Link>
              </li>
              <li>
                <Link to="/Readmore">Why Delmen</Link>
              </li>
              <li>
                <Link to="/contactus">Contact Us</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="dm-footer-offices">
          {offices.map((office) => (
            <div className="dm-footer-office" key={office.title}>
              <p className="dm-footer-heading">{office.title}</p>
              <p className="dm-footer-person">{office.person}</p>
              <a href={office.phoneLink} className="dm-footer-phone">
                <CallIcon /> {office.phone}
              </a>
              <p className="dm-footer-address">
                <PlaceOutlinedIcon />
                <span>{office.address.join(" ")}</span>
              </p>
            </div>
          ))}
        </div>

        <div className="dm-footer-bottom">
          <span>© {new Date().getFullYear()} Delmen Mosquito Screens™. All rights reserved.</span>
          <Link to="/contactus">Send an enquiry →</Link>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
